export const statisticTablesSoldStyle = {
	wrapper: {
		width: '100%',
		height: '100%',
		overflow: 'inherit',
	},

	searchButton: {
		textTransform: 'inherit',
		width: '200px',

		'& svg': {
			width: '24px',
			height: '24px',

			'& path': {
				fill: 'var(--default-white)',
			},
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
	},

	container: {
		marginBottom: '40px',
	},

	table: {
		maxWidth: '1074px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			width: '9%',
		},
		'& > :nth-of-type(2)': {
			width: '28%',
		},
		'& > :nth-of-type(3)': {
			width: '17%',
		},
		'& > :nth-of-type(4)': {
			width: '28%',
		},
		'& > :nth-of-type(5)': {
			width: '9%',
		},
		'& > :nth-of-type(6)': {
			width: '9%',
		},
	},

	tableBody: {
		'& > :nth-of-type(1)': {
			fontSize: '16px',
		},

		'& > :nth-of-type(2)': {
			fontWeight: 700,
		},

		'& > :nth-of-type(4)': {
			fontWeight: 700,
		},

		'& > :nth-of-type(5)': {
			fontSize: '16px',
		},

		'& .MuiTableCell-root': {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			height: '48px',
			paddingTop: '8px !important',
			paddingBottom: '8px !important',
		},
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	pagination: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '16px',
		marginBottom: '48px',
	},
};
